export default {
    name: 'inputspending',
    component: () => import(/* webpackChunkName: "inputs-pending-layout" */ '@/modules/inputs/pending/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.inputs.pending.index',
            component: () => import(/* webpackChunkName: "inputs-pending-index" */ '@/modules/inputs/pending/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.inputs.pending.create',
            component: () => import(/* webpackChunkName: "inputs-pending-create" */ '@/modules/inputs/pending/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.inputs.pending.edit',
            component: () => import(/* webpackChunkName: "inputs-pending-edit" */ '@/modules/inputs/pending/views/Edit'),
        },
        {
            path: ':id/print',
            name: 'dashboard.inputs.pending.print',
            component: () => import(/* webpackChunkName: "inputs-pending-edit" */ '@/modules/inputs/pending/views/Print'),
        },
    ]
}